import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2c78bd1c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c78bd1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\baby_doctor_platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c78bd1c')) {
      api.createRecord('2c78bd1c', component.options)
    } else {
      api.reload('2c78bd1c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2c78bd1c&scoped=true", function () {
      api.rerender('2c78bd1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/classFormat/index.vue"
export default component.exports